<template>
  <div class="boxbgcolor ioRecord">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label>车牌号码</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label>订单号</label>
            <input
              v-model="search.orderNum"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <!-- <div class="form-group">
            <label>发票性质</label>
            <input
              v-model="search.invoiceNatrue"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div> -->
          <div class="form-group others">
            <span class="search_btn">
              <el-button @click="searchList" type="primary" :loading="loading" size="small">查询</el-button>
            </span>
            <!-- <span class='add_btn'><button type="button" class="btn btn-default" id="addarea" @click="addOrEdit()">发票开具</button></span> -->
          </div>
        </form>
      </div>
      <template>
        <div class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            v-loading="loading"
          >
            <el-table-column show-overflow-tooltip label="车牌号码" prop="plateNumber"></el-table-column>
            <el-table-column show-overflow-tooltip label="订单号" prop="orderNum"></el-table-column>
            <el-table-column show-overflow-tooltip label="开票时间" prop="billingTime"></el-table-column>
            <el-table-column show-overflow-tooltip label="销售单号" prop="salesOrderNumber"></el-table-column>
            <el-table-column show-overflow-tooltip label="购方名称" prop="purchaserName"></el-table-column>
            <el-table-column show-overflow-tooltip label="购方税号" prop="purchaserTaxpayerIdentifyNumber"></el-table-column>
            <el-table-column show-overflow-tooltip label="购方手机" prop="purchaserMobilePhone"></el-table-column>
            <el-table-column show-overflow-tooltip label="购方邮箱" prop="purchaserMail"></el-table-column>
            <el-table-column show-overflow-tooltip label="开票员" prop="billMan"></el-table-column>

            <el-table-column show-overflow-tooltip label="发票性质" prop="invoiceNatrue">
               <template slot-scope="scope">
                <span v-if="scope.row.invoiceNature==0">作废成功</span>
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip label="发票代码" prop="invoiceCode"></el-table-column>
            <el-table-column show-overflow-tooltip label="发票号码" prop="invoiceNumber"></el-table-column>
            <el-table-column show-overflow-tooltip label="金额" prop="money"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作人" prop="invoiceOperator"></el-table-column>

            <el-table-column show-overflow-tooltip label="状态" prop="invoiceStatus">
              <template slot-scope="scope">
                <span v-if="scope.row.invoiceStatus==0">失败</span>
                <span v-if="scope.row.invoiceStatus==1">成功</span>
                <span v-if="scope.row.invoiceStatus==2">冲红</span>
              </template>
            </el-table-column>
            <el-table-column  show-overflow-tooltip label="电子发票" width="150px">
              <template slot-scope="scope">
                <button v-if="scope.row.invoiceStatus==1" class="electronicIinvoice" type="button" v-bind:class="{forbid: scope.row.invoiceStatus==0||scope.row.invoiceStatus==2}"
                  @click="electronicIinvoice(scope.row.pdfUrl)">下载</button>
              </template>
            </el-table-column>
            <el-table-column width="200px" show-overflow-tooltip label="操作">
              <template slot-scope="scope">
                <button
                  class="edit"
                  type="button"
                  v-bind:class="{ forbid: scope.row.invoiceStatus==0||scope.row.invoiceStatus==2}"
                  @click="invoiceRedPunch(scope.row.invoiceStatus,scope.row.id)"
                >冲红</button>
                <button
                  class="delete"
                  type="button"
                  v-bind:class="{ forbid: scope.row.invoiceStatus==1||scope.row.invoiceStatus==2}"
                  @click="invoiceReInvoicing(scope.row)"
                >重开</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <Page v-show="showList" v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
      <el-dialog
          title="发票开具"
          :close-on-click-modal="false"
          :lock-scroll="false"
          :visible.sync="dialogFormVisible"
          width="430px"
        >
      <el-form
        ref="form"
        label-position="right"
        :model="form"
        :label-width="formLabelWidth"
      >
        <el-form-item label="购方名称">
          <el-col :span="18">
            <el-input  v-model="form.purchaserName" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="购方税号">
          <el-col :span="18">
            <el-input  v-model="form.purchaserTaxpayerIdentifyNumber" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="购方地址">
          <el-col :span="18">
            <el-input v-model="form.purchaserAddressPhone" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-col :span="18">
            <el-input  v-model="form.purchaserBankAccount"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="购方手机">
          <el-col :span="18">
            <el-input v-model="form.purchaserMobilePhone"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="购方邮箱">
          <el-col :span="18">
            <el-input  v-model="form.purchaserMail"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="开票金额">
          <el-col :span="18">
            <el-input  v-model="form.money"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="invoiceReInvoicingTrue">重开</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getInvoiceReInvoicing,
  getInvoiceRedPunch,
  getParkingDayReportList,
  getParkingDayList,
  invoiceConfigure,
  invoiceConfigureAddOrEditTrue,
  delUser
} from "@/api/url";
import AreaTree from "../../commons/areaTree";
import Page from "../../commons/page";
export default {
  data() {
    return {
      treeData: {
        propertyId: ""
      },
      moduleName: "parking",
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      dialogFormVisible: false,
      formLabelWidth: "100px",
      switchValue: "list",
      showList: true,
      showChart: false,
      showTimeDay: true,
      showTimeMonth: false,
      form: {
        purchaserName: "",
        purchaserTaxpayerIdentifyNumber: "",
        purchaserAddressPhone: "",
        purchaserBankAccount: "",
        purchaserMobilePhone: "",
        purchaserMail: "",
        money: "",
        plateNumber:"",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        invoiceNatrue: "",
        orderNum: "",
        plateNumber: "",
      },
      value4: "",
      tableListData: [],
      tableListDataTitle: [],
      pageObj: {},
      loading: false
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.propertyId) {
        this.$message({
          type: "warning",
          message: "请选择物业！"
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.search.invoiceNatrue = "";
      this.search.plateNumber = "";
      this.search.orderNum = "";
      this.value4 = "";
      if (node.type == "property") {
        this.treeData.propertyId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.propertyId = "";
        this.tableListData = [];
        var pageObj = {
          curIndex: 1,
          rowsCount: 0
        };
        this.getPage(pageObj);
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.$postRequest(invoiceConfigure(),{
          page: curPage,
          limit: this.search.pageSize,
          propertyId: this.treeData.propertyId,
          // invoiceNatrue: this.search.invoiceNatrue,
          orderNum: this.search.orderNum,
          plateNumber: this.search.plateNumber
      }).then(data => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total
          };
          _this.pageObj={...pageObj}
          // _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
        }).finally(() => {  this.loading = false; });
    },
    invoiceReInvoicingTrue() {
      if (!this.form.purchaserName) {
        return this.$message({
          type: "warning",
          message: "购方名称不能为空"
        });
      }
      if (!this.form.purchaserTaxpayerIdentifyNumber) {
        return this.$message({
          type: "warning",
          message: "购方税号不能为空"
        });
      }
      

    },
     searchList() {
    
        if (this.treeData.propertyId) {
          this.search.pageNumber = "1";
          this.tableList(this.search.pageNumber);
        
        } else {
          this.$message({
            message: "请选择物业",
            type: "warning"
          });
        }
    
    },
    clearSearch: function() {
      // this.search.pageNumber = "1";
      // this.search.parkName = "";
    },
    electronicIinvoice() {},
    timeCompare: function(bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    invoiceRedPunch(invoiceStatus,id) {
       if(invoiceStatus==0||invoiceStatus==2){
         return;
       }
      this.$postRequest(getInvoiceRedPunch(), {
        id
      }).then(data => {
        if (data.status != 200) {
          this.$notify.error({
            message: data.message,
            title: "失败"
          });
          return;
        }
        this.$notify({
          type: "success",
          message: "冲红成功",
          title: "成功"
        });
        this.tableList()
      });
    },
    electronicIinvoice(pdfUrl){
   
      window.open(pdfUrl,'_blank')
    },
    invoiceReInvoicing(row){
        if(row.invoiceStatus==1||row.invoiceStatus==2){
         return;
       }
      this.dialogFormVisible=true;

      // debugger
      this.form=row;
    
     
    },
    invoiceReInvoicingTrue(){
      this.dialogFormVisible=false;
       this.$postRequest(getInvoiceReInvoicing(),{
         	id: this.form.id,
          parkingId: this.form.parkingId,
          plateNumber: this.form.plateNumber,
          orderNum: this.form.orderNum,
          salesOrderNumber: this.form.salesOrderNumber,
          purchaserName: this.form.purchaserName,
          purchaserTaxpayerIdentifyNumber: this.form.purchaserTaxpayerIdentifyNumber,
          purchaserMobilePhone: this.form.purchaserMobilePhone,
          purchaserMail: this.form.purchaserMail,
          biller: this.form.billMan,
          invoiceNature: this.form.invoiceNature,
          money:  this.form.money,
          invoiceOperator: this.form.invoiceOperator,
          invoiceStatus: this.form.invoiceStatus,
          crtTime: this.form.crtTime,
          	// id: "afab1c198c0f40949175f",
            // parkingId: "c19f45bbbd164bccb550f37",
            // plateNumber: "京U000",
            // orderNum: "2020040915465",
            // salesOrderNumber: "2020040915465",
            // purchaserName: "深圳市坪山区a",
            // purchaserTaxpayerIdentifyNumber: "91140108468716",
            // purchaserMobilePhone: "13412345",
            // purchaserMail: "13@qq.com",
            // biller: "adm",
            // invoiceNature: "0",
            // money: "21.11",
            // invoiceOperator: "admin",
            // invoiceStatus: "1",
            // crtTime: "2020-04-20 19:59:33"
        }).then(data=>{
          if(data.status !=200){
            this.$notify.error({
              message:data.message,
              title:"失败"
            });
            return;
          }
          this.$notify({
            type:"success",
            message:"重开成功",
            title:"成功"
          });
          this.tableList()
        })
      }
  },
  computed: {
    ...mapState({
      curIndex: state => state.page.curIndex,
      rowsCount: state => state.page.rowsCount,
      nodeData: state => state.nodeData,
      nod: state => state.nod
    })
  },
  components: {
    Page,
    AreaTree
  },

  mounted: function() {
    //  this.tableList(this.pageNumber);
    //  this.tableListByDay();
    // this.getDateNow();
    // this.tableList(this.search.pageNumber);
  },
  watch: {
    // switchValue: function(newVal, oldVal) {
    //   if (newVal === "chart") {
    //     this.showChart = true;
    //     this.showList = false;
    //     this.$nextTick(function() {
    //       let myChart = this.$echarts.init(document.getElementById("myChart"));
    //       myChart.setOption(this.myChart);
    //     });
    //   } else {
    //     this.showChart = false;
    //     this.showList = true;
    //   }
    // }
  }
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.searchboxTo {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  margin-left: 120px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
.electronicIinvoice {
  display: inline-block;
  width: 60px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
}
.forbid {
  color: #ddd !important;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>